import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { SubscribedAccountList } from "./subscribedAccountList";

const companyBreadcrumbs: Array<PageLink> = [
  {
    title: "Subscribed Data",
    path: "/subscribedAccounts/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const SubscribedAccountPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={companyBreadcrumbs}>Subscription list</PageTitle>
              <SubscribedAccountList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/subscribedAccounts/list" />} />
    </Routes>
  );
};

export default SubscribedAccountPage;
